import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import AdminLocks from "./AdminLocks";
import AdminLock from "./AdminLock";
import AdminProxy from "./AdminProxy";
import { UseLivlyLeaseUser } from "shared/api/LivlyUserProvider";
import { isSuperUser } from "shared/api/isSuperUser";
import { getCurrentTenantName } from "helpers";
import { AdminLocksTab, AdminLocksTabValue, ProxyScope, ProxyScopeValue } from "./constants";

export default function Locks() {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [tab, setTab] = useState<AdminLocksTabValue>(AdminLocksTab.LOCKS);
  const [proxyScope, setProxyScope] = useState<ProxyScopeValue>(ProxyScope.TENANT);
  const [doorType, setDoorType] = useState("");
  const [siteId, setSiteId] = useState("");
  const [search, setSearch] = useState("");
  const user = UseLivlyLeaseUser();
  const isSuperUserPermission = isSuperUser(user);
  const currentTenantName = getCurrentTenantName(user);

  return (
    <Routes>
      <Route
        index
        element={
          <AdminLocks
            search={search}
            setSearch={setSearch}
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            tab={tab}
            setTab={setTab}
            proxyScope={proxyScope}
            setProxyScope={setProxyScope}
            isSuperUser={isSuperUserPermission}
            currentTenantName={currentTenantName}
            doorType={doorType}
            setDoorType={setDoorType}
            siteId={siteId}
            setSiteId={setSiteId}
          />
        }
      />
      <Route path="proxies/:proxyId/*" element={<AdminProxy />} />
      <Route path=":lockId/*" element={<AdminLock />} />
    </Routes>
  );
}
